import queryString from 'query-string';
import history from '../../history';

const isClient = process.env.BROWSER;
const HOST = process.env.HOST || process.env.WEBSITE_HOSTNAME;

export function getMake(make) {
  return (make && (typeof make === 'string' ? make : make.slug)) || '';
}

export const generateUrl = car => {
  if (!car.permalink) {
    return `${car.make && getMake(car.make)}-${car.model &&
      car.model.slug}-${car.year}-${car.location && car.location.slug}-1-${car.id}-1.html`;
  }
  return car.permalink;
};

const getRangeNumber = (number, rangePercent = 20) => {
  const precentValue = number / 100 * rangePercent;
  const from = Math.round(number - precentValue);
  const to = Math.round(number + precentValue);
  return { from, to };
};

export const generateSearchQuery = select => {
  const query = {};

  Object.keys(select).forEach(key => {
    if (select[key] === null || select[key] === undefined) {
      return null;
    } else if (key === 'colors') {
      query[key] = select[key];
    } else if (key === 'currency') {
      query[key] = select[key].slug || select[key];
    } else if (Object.keys(select[key]).length > 0 && typeof select[key] === 'object') {
      query[key] = select[key].id || select[key].value;
    } else if (key === 'options') {
      query[key] = Object.keys(select[key]);
    } else if (key === 'prepaid') {
      const range = getRangeNumber(select[key]);
      query.prepaid_sum__gte = range.from;
      query.prepaid_sum__lte = range.to;
      query[key] = select[key];
    } else if (key === 'monthly') {
      const range = getRangeNumber(select[key]);
      query.monthly_payment__gte = range.from;
      query.monthly_payment__lte = range.to;
      query[key] = select[key];
    } else {
      query[key] = select[key];
    }
    return query;
  });
  return query;
};

export const generateSearchUrl = (
  { transport, isNew, make, model, year, location, transportChild },
  isCountry = false,
) => {
  const result = [
    transport && transport.slug,
    isNew && transport && 'novye',
    make && getMake(make),
    model && model.slug,
    year && `god-${year}`,
    transportChild && transportChild.slug,
    location &&
      (!isNew && transport && transport.slug === 'avto' ? true : !isCountry) &&
      `${location.slug}`,
    '/',
  ]
    .filter(i => !!i)
    .join('/')
    .replace(/\/\//g, '/');
  return result;
};

export const generateDealersSearchUrl = ({ transport, make, model, location }) =>
  [
    'avtosalony',
    transport && transport.slug !== 'avto' && transport.slug,
    make && getMake(make),
    model && model.slug,
    location && `${location.slug}`,
    '/',
  ]
    .filter(i => !!i)
    .join('/')
    .replace(/\/\//g, '/');

export const generateFirmsSearchUrl = ({ tag, location }) =>
  ['katalog-kompaniy', tag && tag.slug, location && `${location.slug}/`]
    .filter(i => !!i)
    .join('/')
    .replace(/\/\//g, '/');

export const generateSparesSearchUrl = ({ transport, rubric, sparetype, make, model, location }) =>
  [
    'zapchasti',
    transport && transport.slug !== 'avto' && transport.slug,
    rubric && rubric.slug,
    sparetype && sparetype.slug,
    make && getMake(make),
    model && model.slug,
    location && location.slug,
    '/',
  ]
    .filter(i => !!i)
    .join('/')
    .replace(/\/\//g, '/');

export const generateFirmSparesSearchUrl = ({
  transport,
  rubric,
  sparetype,
  make,
  model,
  location,
}) =>
  [
    location && location.pathname,
    transport && transport.slug !== 'avto' && transport.slug,
    ...(transport && transport.slug === 'avto'
      ? [rubric && rubric.slug, sparetype && sparetype.slug]
      : []),
    make && getMake(make),
    model && model.slug,
    '/',
  ]
    .filter(i => !!i)
    .join('/')
    .replace(/\/\//g, '/');

export const transformQuery = (propQuery, data, param) => {
  const query = { ...propQuery };
  if (data === '' || data === null) {
    delete query[param];
  } else {
    query[param] = data;
  }
  query.page = 1;

  return query;
};

export const changeQuery = (url, query) => {
  history.push(`${url}?${queryString.stringify(query)}`);
};

export const shouldDisplayCountries = (path, routeName, formState) =>
  !path.includes('/novye') &&
  (formState && formState.transport ? formState.transport.slug === 'avto' : true) &&
  routeName !== 'dealers' &&
  routeName !== 'moto' &&
  routeName !== 'firms' &&
  routeName !== 'dealer' &&
  routeName !== 'auto-parts';

export const getIdFromSpareUrl = url => {
  if (url.match(/([0-9]-)([0-9])+(-[0-9].html)/g)) {
    return url.match(/([0-9]-)([0-9])+(-[0-9].html)/g)[0].split('-')[1];
  } else if (url.match(/[0-9]+.html/g)) {
    return url.match(/[0-9]+.html/g)[0].replace('.html', '');
  } else if (url.match(/[0-9]+$/g)) {
    return url.match(/[0-9]+$/g);
  }

  return null;
};

export const generateJournalhUrl = ({ topic, make, model }) =>
  ['/zhurnal/video/', topic && topic.seo_slug, make && getMake(make), model && model.slug]
    .filter(i => !!i)
    .join('/')
    .replace(/\/\//g, '/');

export const getDealerLink = dealer => {
  const url = dealer.is_dealer ? 'avtosalony' : 'katalog-kompaniy';
  return `/${url}/${dealer.slug}/`;
};

export const translateSeoLinks = (links, t) => {
  const availableKeys = { categories: 1, engines: 1, gearboxes: 1, rubrics: 1 };
  if (t('locale') === 'ru') return links || {};

  Object.keys(links || {}).forEach(key => {
    if (!availableKeys[key]) return;
    (links[key] || []).forEach(item => {
      item.locale_title = item.uk_title || t(item.title);
    });
  });
  return links || {};
};

export function getBaseURL() {
  const host = (isClient && location && location.host) || HOST || 'avtobazar.ua';
  const protocol = (isClient && location && location.protocol) || 'https:';
  return `${protocol}//${host}`;
}



// WEBPACK FOOTER //
// ./src/shared/helpers/urls.js